import React,{useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Button from '@material-ui/core/Button'

import Section from './Section'

import Grid from './Grid'
import Carousel from './Carousel'

const listVariantMaps = {
  Grid: Grid,
  Slideshow: Carousel,
  SlideshowLeft: Carousel,
}

const styles = theme => ({
  container: {
    marginLeft: -theme.spacing.unit * 2,
    width: `calc(100% + ${theme.spacing.unit*4}px)`,
    paddingLeft: theme.spacing.unit * 2,
    overflow: 'scroll',
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit * 2,
  },
  row: {
    width: 1000
  },
  item: {
    marginRight: theme.spacing.unit
  },
});

const FilterItem = ({ theme, classes, title, selected, onClick }) => {
  return (
    <Button variant="contained" size="medium" 
      color='primary'
      className={classes.item}
      aria-label="" 
      onClick={onClick}
    > { title }
    </Button>
  )
}

const TitleFilterSection = (props) => {
  const { theme, classes, openLink, selected_index, onClick, variant, color, item_size, item_variant, item_count, items } = props

  let textColor
  if(color === 'dark'){
    textColor =  theme.sectionPalette.dark.contrastText
  }else if(color === 'accent'){
    textColor =  theme.sectionPalette.accent.contrastText
  }else if(color === 'light'){
    textColor =  theme.sectionPalette.light.contrastText
  }else if(color === 'white'){
    textColor =  theme.sectionPalette.white.contrastText
  }else{
    textColor =  theme.sectionPalette.black.contrastText
  }
  
  return (
    <Section { ...props }>
      <div className={classes.container}>
        <div className={classes.row}>
          { items.map((item, index) => (
            <FilterItem 
              theme={theme} 
              classes={classes} 
              title={item.title}
              selected={index == selected_index ? true : false}
              onClick={()=>onClick(item)}
              />
            ))
          }
        </div>
      </div>
    </Section>
  )
}

TitleFilterSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(TitleFilterSection);